<template>
    <div class="table-row-cells" :id="'patient-invitation-'+patient.invitation_id">
        <slot></slot>

        <div class="table-td cell-status">
            <div>
                <template v-if="hasStatus">
                    <div v-if="patient.status.used_code && !patient.status.pre_reg" class="status-item used-code">
                        <figure class="status-icon">
                            <svg-icon icon="icon-check-circle-big"></svg-icon>
                        </figure>
                        <strong class="status-text">{{ __('Entered code/free entry') }}</strong>
                    </div>
                    <template v-else>
                        <div :class="['status-item', {'check': patient.status.pre_reg}]">
                            <figure class="status-icon">
                                <svg-icon v-if="patient.status.pre_reg" icon="icon-check-circle-big"></svg-icon>
                                <svg-icon v-else icon="icon-times-circle-big"></svg-icon>
                            </figure>

                            <div>
                                <strong class="status-text">{{ __('Readiness') }}</strong>
                                <strong  class="status-inappropriate tooltip">
                                    <a href="#">{{ __("Not a suitable candidate") }} <figure><span class="material-icons-outlined">info</span></figure></a>
                                    <div class="tooltip-content">
                                        <p>{{ __("According to the motivational pre-form, the patient is probably not a suitable candidate for the programme.") }}</p>
                                    </div>
                                </strong>
                            </div>
                        </div>
                        <div :class="['status-item', {'check': patient.status.registration}]">
                            <figure class="status-icon">
                                <svg-icon v-if="patient.status.registration" icon="icon-check-circle-big"></svg-icon>
                                <svg-icon v-else icon="icon-times-circle-big"></svg-icon>
                            </figure>
                            <strong class="status-text">{{ __('Registration') }}</strong>
                        </div>
                        <div class="status-item">
                            <figure class="status-icon">
                                <svg-icon icon="icon-times-circle-big"></svg-icon>
                            </figure>
                            <strong class="status-text">{{ __('Entry form') }}</strong>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="status-item no-activity">
                        <figure class="status-icon">
                            <svg-icon icon="icon-times-circle-big"></svg-icon>
                        </figure>
                        <div>
                            <strong class="status-text">{{ __('No activity') }}</strong>
                        </div>
                    </div> 
                </template>

            </div>
        </div>

        <div class="table-td cell-invite">
            <span v-if="patient.invitation && patient.invitation.created_at">
                {{ moment(patient.invitation.created_at).format('D. M. YYYY') }}

                <small v-if="!patient.status.registration && patient.days_to_expiration !== null">
                    {{ __("Expires in") }} {{ patient.days_to_expiration }} {{ __choice("days", patient.days_to_expiration) }}
                </small>
            </span>
        </div>

        <div class="table-td cell-therapist">
            <user-avatar v-if="patient.invitation" :user-info="patient.invitation.doctor.user" size="xs"></user-avatar>

            <span v-if="patient.invitation">{{ patient.invitation.doctor.user | fullname }}</span>
        </div>

        <div class="table-td cell-institution">
            <span v-if="patient.invitation">
                <figure>
                    <img :src="patient.invitation.doctor.institution.icon" :alt="patient.invitation.doctor.institution.name" id="profile-img" height="38" width="38">
                </figure>

                <span>{{ patient.invitation.doctor.institution.name }}</span>
            </span>
        </div>

        <div class="table-td cell-controls event-date">
            <template v-if="!patient.status.registration && patient.invitation">
                <button aria-expanded="false" aria-haspopup="true" class="event-dropdown-toggle event-control" data-toggle="dropdown" type="button">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <div class="controls-wrapper">
                    <nav class="controls-nav">
                        <ul>
                            <li v-if="!patient.patient_id && patient.email">
                                <a href="">
                                    <span>{{ __("Resend again") }}</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" data-target="#modal-delete-invitation" data-toggle="modal" data-dismiss="modal" @click="setPatientInvitationId(patient.invitation_id)">
                                    <span>{{ __("Delete invitation") }}</span>
                                </a>
                            </li>
                        </ul>
                    </nav>

                    <div class="controls-calendar">
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        patient: {
            type: Object,
            required: true
        }
    },

    computed: {
        hasStatus() {
            if(this.patient.status.pre_reg || this.patient.status.registration || this.patient.status.used_code) {
                return true
            } else {
                return false
            }
        }
    },

    methods: {
        setPatientInvitationId(id) {
            window.invitation_id = id
        }
    }
}
</script>
